
import request from '@/service/request'

export const getOrderPage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<ORDER.Detail[]>>({
    url: '/admin/order/page',
    method: 'GET',
    params
  })
}

export const delOrder = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/order/' + id,
    method: 'DELETE'
  })
}

export const getOrderById = (id: string) => {
  return request<SERVICE.Response<ORDER.Detail>>({
    url: '/admin/order/' + id,
    method: 'GET'
  })
}

export const exportExcelOrder = (params: any) => {
  return request<Blob>({
    url: '/admin/exportExcel/order',
    method: 'GET',
    params,
    responseType: 'blob'
  })
}

export const getWaitExpressCount = () => {
  return request<SERVICE.Response<number>>({
    url: '/admin/order/waitExpress/num',
    method: 'GET',
    headers: {
      platform: 'health'
    }
  })
}

export const refund = (data: {
  'orderId': number,
  'refundReason'?: string
}) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/orderPay/refund',
    method: 'POST',
    data
  })
}

// 拒绝退款
export const refuseRefund = (data: {
  'orderId': string,
  'refundReason'?: string
}) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/orderPay/refundFail?=orderId' + `${data.orderId}&refundReason=${data.refundReason}`,
    method: 'POST',
    data
  })
}

export const cashbackMountByOrder = (id: string, cashbackMount: number) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/order/${id}/cashbackMount?cashbackMount=${cashbackMount}`,
    method: 'PUT'
  })
}

export const getOrderDistribution = (orderId: string) => {
  return request<SERVICE.ResponsePage<ORDER.Distribution[]>>({
    url: `/admin/order-distribution/${orderId}`,
    method: 'GET'
  })
}
